<div class="mb-6 px-3">
  <div class="w-fit rounded-2xl border border-gray-300 bg-gradient-to-r from-gray-50 to-white px-5 py-3">
    <div class="border-l-4 border-gray-800 pl-4">
      <p class="text-xs font-semibold uppercase tracking-[0.18em] text-gray-500">
        Social Posts Section
      </p>
      <h2 class="mt-1 text-2xl font-bold leading-tight tracking-tight text-gray-900">
        Create Post
      </h2>
    </div>
  </div>
</div>

<div class="grid grid-cols-12 gap-6 mt-2">
  <div class="col-span-12 px-3 2xl:col-span-9">
    <div class="overflow-hidden rounded-3xl border border-gray-300 bg-white">
      <form
        *ngIf="postForm as form"
        [formGroup]="form"
        class="mx-auto max-w-6xl p-5 sm:p-8 lg:p-10"
        (ngSubmit)="submit()"
      >
        <div class="mb-10 text-center">
          <p class="text-sm font-semibold uppercase tracking-[0.18em] text-blue-600">
            Composer
          </p>
          <h1 class="mt-3 text-3xl font-bold tracking-tight text-gray-950 sm:text-4xl">
            Create New Post
          </h1>
          <p class="mx-auto mt-3 max-w-2xl text-sm leading-6 text-gray-500 sm:text-base">
            Select the details, upload media, and schedule your new social post.
          </p>
        </div>

        <div class="grid grid-cols-1 gap-8 lg:grid-cols-2">
          <!-- Left side -->
          <div>
            <!-- Site -->
            <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
              <label class="mb-2 block text-sm font-semibold text-gray-800">
                Choose Social Page/Site
              </label>
              <select
                formControlName="site"
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              >
                <option value="">Choose Social Page/Site</option>
                <option *ngFor="let s of sites" [value]="s.Domain">
                  {{ s.Domain }}
                </option>
              </select>
            </div>

            <!-- Feed -->
            <div *ngIf="feeds.length > 0" class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
              <label class="mb-2 block text-sm font-semibold text-gray-800">
                Post Category
              </label>
              <select
                formControlName="rss_feed_id"
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              >
                <option value="" disabled>Select a Category</option>
                <option *ngFor="let f of feeds" [value]="f.id">
                  {{ f.feed }}
                </option>
              </select>
            </div>

            <!-- Platform -->
            <div
              *ngIf="
                form.get('rss_feed_id')?.value && filteredPlatforms.length > 0
              "
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5"
            >
              <label class="mb-3 block text-sm font-semibold text-gray-800">
                Choose Platform
              </label>

              <div class="grid grid-cols-1 gap-3 sm:grid-cols-2">
                <label
                  *ngFor="let p of filteredPlatforms"
                  class="flex cursor-pointer items-center rounded-xl border border-gray-300 bg-white p-4 transition-all hover:border-blue-500"
                >
                  <input
                    type="radio"
                    formControlName="platform"
                    [value]="p.platform"
                    class="text-blue-600 focus:ring-blue-500"
                  />
                  <span class="ml-3 text-sm font-semibold text-gray-800">
                    {{ p.platform }}
                    <span class="mt-0.5 block text-xs font-medium text-gray-400">
                      {{ p.domain }}
                    </span>
                  </span>
                </label>
              </div>
            </div>

            <!-- Format -->
            <div *ngIf="filteredTags.length > 0" class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
              <label class="mb-2 block text-sm font-semibold text-gray-800">
                Choose Format
              </label>
              <select
                formControlName="tag"
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              >
                <option value="" disabled>Select a format</option>
                <option
                  *ngFor="let displayTag of getDisplayTagsForPlatform(filteredTags)"
                  [value]="displayTagMap[displayTag]"
                >
                  {{ displayTag }}
                </option>
              </select>
            </div>

            <!-- Video Type Dropdown -->
            <div
              *ngIf="allVideoTags.includes(form.get('tag')?.value)"
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5"
            >
              <label class="mb-2 block text-sm font-semibold text-gray-800">
                Video Type
              </label>
              <select
                formControlName="video_type_id"
                class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              >
                <option [ngValue]="null" disabled>Select video type</option>

                <ng-container *ngFor="let vt of videoTypes">
                  <option
                    *ngIf="
                      vt.video_type_name !== 'ai_video' &&
                      !(
                        vt.video_type_name === 'video_url' &&
                        (
                          form.get('platform')?.value === 'Instagram' ||
                          form.get('platform')?.value === 'TikTok' ||
                          form.get('tag')?.value === 'igstoryvideo' ||
                          form.get('tag')?.value === 'fbstoryvideo' ||
                          form.get('tag')?.value === 'tiktokstoryvideo'
                        )
                      )
                    "
                    [ngValue]="vt.id"
                  >
                    {{
                      vt.video_type_name === 'video_upload'
                        ? 'Upload A Video'
                        : vt.video_type_name === 'video_url'
                          ? 'YouTube Link'
                          : vt.video_type_name
                    }}
                  </option>
                </ng-container>
              </select>
            </div>

            <!-- Video Upload -->
            <div
              *ngIf="form.get('video_type')?.value === 'video_upload'"
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5 text-center"
            >
              <label
                class="inline-flex cursor-pointer items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
              >
                Upload MP4 Video
                <input
                  type="file"
                  accept="video/mp4"
                  (change)="onVideoFileSelected($event)"
                  class="hidden"
                />
              </label>

              <div *ngIf="videoFileName" class="mt-3 text-sm font-medium text-gray-600">
                {{ videoFileName }}
              </div>

              <div
                *ngIf="
                  form.get('video_file')?.invalid &&
                  form.get('video_file')?.touched
                "
                class="mt-2 text-xs font-medium text-red-500"
              >
                MP4 video is required
              </div>
            </div>

            <!-- Cover Frame Picker -->
            <div
              *ngIf="
                form.get('video_type')?.value === 'video_upload' &&
                coverFrames.length > 0
              "
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5"
            >
              <label class="mb-3 block text-sm font-semibold text-gray-800">
                Choose Cover Frame
              </label>

              <div class="grid grid-cols-2 gap-3 sm:grid-cols-4">
                <button
                  type="button"
                  *ngFor="let fr of coverFrames"
                  (click)="selectCoverFrame(fr)"
                  class="relative cursor-pointer overflow-hidden rounded-xl border border-gray-300 bg-white transition hover:border-blue-500"
                  [ngClass]="{
                    'border-blue-600 ring-2 ring-blue-200':
                      selectedCoverFrameDataUrl === fr.dataUrl,
                    'border-gray-300 hover:border-blue-500':
                      selectedCoverFrameDataUrl !== fr.dataUrl
                  }"
                >
                  <img
                    [src]="fr.dataUrl"
                    class="h-24 w-full object-cover"
                    draggable="false"
                  />
                  <span class="absolute bottom-1.5 right-1.5 rounded-md bg-black/70 px-1.5 py-0.5 text-[10px] font-semibold text-white">
                    {{ fr.time | number : '1.0-2' }}s
                  </span>
                </button>
              </div>

              <p class="mt-3 text-xs leading-5 text-gray-500">
                This image will be used as the video thumbnail / preview.
              </p>
            </div>

            <!-- YouTube URL -->
            <div
              *ngIf="form.get('video_type')?.value === 'video_url'"
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5"
            >
              <label class="mb-2 block text-sm font-semibold text-gray-800">
                YouTube URL
              </label>

              <input
                type="text"
                formControlName="video_url"
                placeholder="https://youtube.com/..."
                [attr.dir]="textDirection"
                class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
              />

              <div
                *ngIf="
                  form.get('video_url')?.invalid &&
                  form.get('video_url')?.touched
                "
                class="mt-2 text-xs font-medium text-red-500"
              >
                <span *ngIf="form.get('video_url')?.errors?.['pattern']">
                  Invalid YouTube video URL.
                </span>
              </div>
            </div>

            <!-- Text Direction Switch -->
            <div
              *ngIf="form.get('tag')?.value"
              class="mb-6 flex flex-col gap-4 rounded-2xl border border-gray-300 bg-gray-50/60 p-5 sm:flex-row sm:items-center sm:justify-between"
            >
              <label class="block text-sm font-semibold text-gray-800">
                Text Direction
              </label>

              <div class="inline-flex w-fit rounded-xl border border-gray-300 bg-white p-1">
                <button
                  type="button"
                  (click)="
                    $event.preventDefault();
                    $event.stopPropagation();
                    setTextDirection('ltr')
                  "
                  [class.bg-blue-600]="textDirection === 'ltr'"
                  [class.text-white]="textDirection === 'ltr'"
                  class="rounded-lg px-5 py-2 text-sm font-semibold text-gray-700 transition disabled:cursor-not-allowed disabled:opacity-50"
                  [disabled]="isEditBlocked"
                >
                  LTR
                </button>

                <button
                  type="button"
                  (click)="
                    $event.preventDefault();
                    $event.stopPropagation();
                    setTextDirection('rtl')
                  "
                  [class.bg-blue-600]="textDirection === 'rtl'"
                  [class.text-white]="textDirection === 'rtl'"
                  class="rounded-lg px-5 py-2 text-sm font-semibold text-gray-700 transition disabled:cursor-not-allowed disabled:opacity-50"
                  [disabled]="isEditBlocked"
                >
                  RTL
                </button>
              </div>
            </div>

            <!-- Description, URL, Caption, Status -->
            <ng-container
              *ngIf="
                form.get('tag')?.value &&
                form.get('tag')?.value !== 'photolink'
              "
            >
              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <label class="block flex items-center gap-2 text-sm font-semibold text-gray-800">
                    Post Description
                  </label>
                  
                  <!-- we hide it for now 
                  <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                    Alternative AI Prompt
                  </mat-checkbox>
                  -->
                </div>

                <textarea
                  formControlName="rss_description"
                  rows="3"
                  placeholder="Enter description..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                ></textarea>
              </div>

              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <label class="mb-2 block text-sm font-semibold text-gray-800">
                  URL
                </label>
                <input
                  formControlName="rss_article_url"
                  type="text"
                  placeholder="https://..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                />
                <div
                  *ngIf="
                    form.get('rss_article_url')?.invalid &&
                    form.get('rss_article_url')?.touched
                  "
                  class="mt-2 text-xs font-medium text-red-500"
                >
                  <span *ngIf="form.get('rss_article_url')?.errors?.['pattern']">
                    Enter a valid URL (e.g., https://example.com).
                  </span>
                </div>
              </div>

              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <label class="mb-2 block text-sm font-semibold text-gray-800">
                  Caption
                </label>
                <textarea
                  formControlName="post_title"
                  rows="2"
                  placeholder="Enter title..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                ></textarea>
              </div>

              <div class="grid grid-cols-1 gap-4 rounded-2xl border border-gray-300 bg-gray-50/60 p-5 sm:grid-cols-2">
                <div>
                  <label class="mb-2 block text-sm font-semibold text-gray-800">
                    Post Status
                  </label>
                  <select
                    formControlName="post_status"
                    class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="" disabled>Select a status</option>
                    <option *ngFor="let s of filteredPostStatuses" [value]="s.value">
                      {{ s.label }}
                    </option>
                  </select>
                </div>

                <div>
                  <label class="mb-2 block text-sm font-semibold text-gray-800">
                    Schedule Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    formControlName="scheduled_for"
                    class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
                  />
                </div>
              </div>
            </ng-container>
          </div>

          <!-- Right side -->
          <div>
            <!-- Multiple Images -->
            <div
              *ngIf="multiImageTags.includes(form.get('tag')?.value)"
              class="mb-6 cursor-pointer rounded-3xl border-2 border-dashed border-gray-300 bg-gray-50/70 p-8 text-center transition-colors hover:border-blue-500 hover:bg-blue-50/40"
              (drop)="onFilesDropped($event)"
              (dragover)="onDragOver($event)"
            >
              <div class="flex flex-col items-center">
                <div class="flex h-16 w-16 items-center justify-center rounded-2xl border border-gray-300 bg-white">
                  <svg class="h-9 w-9 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
                    />
                  </svg>
                </div>

                <p class="mt-5 text-sm font-semibold text-gray-700">
                  Drag & Drop your images here
                </p>
                <p class="mt-1 text-sm text-gray-400">
                  or click to browse images
                </p>

                <input
                  type="file"
                  multiple
                  (change)="onMultipleFilesSelected($event)"
                  class="hidden"
                  #fileInput
                />

                <button
                  type="button"
                  class="mt-5 cursor-pointer rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
                  (click)="fileInput.click()"
                >
                  Select Images
                </button>
              </div>
            </div>

            <!-- Single Image -->
            <div
              *ngIf="singleImageTags.includes(form.get('tag')?.value)"
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5 text-center"
            >
              <div class="flex flex-col sm:flex-row justify-center gap-3">
                <label
                  class="inline-flex cursor-pointer items-center justify-center rounded-xl bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
                >
                  Choose Image
                  <input
                    type="file"
                    (change)="onFileSelected($event)"
                    accept="image/*"
                    class="hidden"
                  />
                </label>

                <button
                  type="button"
                  (click)="openAiImageModal()"
                  class="inline-flex cursor-pointer items-center justify-center rounded-xl bg-green-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-green-700"
                >
                  AI Engine Image
                </button>
               
              </div>
            </div>

            <!-- Image Previews -->
            <div
              *ngIf="imagePreview || uploadedFiles.length > 0"
              class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5"
            >
              <div class="mb-4 flex items-center justify-between">
                <h3 class="text-sm font-semibold text-gray-800">
                  Media Preview
                </h3>

                <button
                  *ngIf="uploadedFiles.length > 1"
                  type="button"
                  class="cursor-pointer text-sm font-semibold text-red-600 transition hover:text-red-700 hover:underline"
                  (click)="clearAll()"
                >
                  Clear All
                </button>
              </div>

              <div *ngIf="imagePreview" class="group relative h-32 w-32">
                <img
                  [src]="imagePreview"
                  draggable="false"
                  class="h-full w-full rounded-2xl border border-gray-300 object-cover transition-transform group-hover:scale-105"
                />
                <button
                  type="button"
                  (click)="removeImage()"
                  class="absolute -right-2 -top-2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-red-600 text-xs font-bold text-white opacity-0 transition hover:bg-red-700 group-hover:opacity-100"
                >
                  ✕
                </button>
              </div>

              <div *ngIf="!imagePreview && uploadedFiles.length > 0">
                <div
                  cdkDropList
                  class="grid w-full grid-cols-2 gap-4 sm:grid-cols-3"
                  (cdkDropListDropped)="dropImages($event)"
                >
                  <div *ngFor="let uf of uploadedFiles; let i = index" cdkDrag>
                    <div class="flex flex-col items-center rounded-2xl border border-gray-300 bg-white p-3">
                      <div class="group relative mb-3 h-28 w-28">
                        <img
                          [src]="uf.preview"
                          alt="preview"
                          class="h-full w-full rounded-xl border border-gray-300 object-cover transition-transform group-hover:scale-105"
                        />
                        <button
                          type="button"
                          (click)="removeFile(i)"
                          class="absolute -right-2 -top-2 flex h-7 w-7 cursor-pointer items-center justify-center rounded-full bg-red-600 text-xs font-bold text-white opacity-0 transition hover:bg-red-700 group-hover:opacity-100"
                        >
                          ✕
                        </button>
                      </div>

                      <div
                        class="alt-input w-full"
                        *ngIf="videoStoryTags.includes(form.get('tag')?.value)"
                      >
                        <label
                          for="alt-text-{{ i }}"
                          class="mb-1 block text-xs font-semibold text-gray-700"
                        >
                          Caption
                        </label>
                        <input
                          id="alt-text-{{ i }}"
                          type="text"
                          class="w-full rounded-lg border border-gray-300 bg-gray-50 px-3 py-2 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
                          [value]="uf.alt"
                          (input)="uploadedFiles[i].alt = $any($event.target).value"
                          placeholder="Enter caption"
                          maxlength="50"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Photolink -->
            <ng-container *ngIf="form.get('tag')?.value === 'photolink'">
              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                  <label class="block flex items-center gap-2 text-sm font-semibold text-gray-800">
                    Post Description
                  </label>

                  <!-- We hide it for now 
                  <mat-checkbox formControlName="is_altai" color="primary" class="text-sm text-gray-700">
                    Alternative AI Prompt
                  </mat-checkbox>
                  -->
                </div>

                <textarea
                  formControlName="rss_description"
                  rows="3"
                  placeholder="Enter description..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                ></textarea>
              </div>

              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <label class="mb-2 block text-sm font-semibold text-gray-800">
                  URL
                </label>
                <input
                  formControlName="rss_article_url"
                  type="text"
                  placeholder="https://..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                />
                <div
                  *ngIf="
                    form.get('rss_article_url')?.invalid &&
                    form.get('rss_article_url')?.touched
                  "
                  class="mt-2 text-xs font-medium text-red-500"
                >
                  <span *ngIf="form.get('rss_article_url')?.errors?.['pattern']">
                    Enter a valid URL (e.g., https://example.com).
                  </span>
                </div>
              </div>

              <div class="mb-6 rounded-2xl border border-gray-300 bg-gray-50/60 p-5">
                <label class="mb-2 block text-sm font-semibold text-gray-800">
                  Caption
                </label>
                <textarea
                  formControlName="post_title"
                  rows="2"
                  placeholder="Enter title..."
                  [attr.dir]="textDirection"
                  class="w-full rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                ></textarea>
              </div>

              <div class="grid grid-cols-1 gap-4 rounded-2xl border border-gray-300 bg-gray-50/60 p-5 sm:grid-cols-2">
                <div>
                  <label class="mb-2 block text-sm font-semibold text-gray-800">
                    Post Status
                  </label>
                  <select
                    formControlName="post_status"
                    class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20"
                  >
                    <option value="" disabled>Select a status</option>
                    <option *ngFor="let s of filteredPostStatuses" [value]="s.value">
                      {{ s.label }}
                    </option>
                  </select>
                </div>

                <div>
                  <label class="mb-2 block text-sm font-semibold text-gray-800">
                    Schedule Date & Time
                  </label>
                  <input
                    type="datetime-local"
                    formControlName="scheduled_for"
                    class="w-full cursor-pointer rounded-xl border border-gray-300 bg-white px-4 py-3 text-sm text-gray-700 transition-colors focus:border-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400"
                  />
                </div>
              </div>
            </ng-container>
          </div>
        </div>

                <!-- Submit -->
        <div *ngIf="form.get('tag')?.value" class="mt-10 flex justify-center border-t border-gray-300 pt-8">
          <button
            type="submit"
            class="inline-flex cursor-pointer items-center gap-2 rounded-2xl bg-gradient-to-r from-blue-600 to-blue-500 px-10 py-4 text-base font-bold text-white transition-all hover:-translate-y-0.5 hover:from-blue-700 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500/30"
          >
            Submit
          </button>
        </div>
      </form>

      <!-- AI Image Creation Modal -->
      <div
        *ngIf="isAiModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/55 px-4 backdrop-blur-[2px]"
      >
        <div
          class="relative w-full max-w-[95vw] overflow-hidden rounded-2xl bg-white shadow-2xl sm:max-w-5xl"
        >
          <div
            class="w-full rounded-t-2xl border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white px-5 py-4"
          >
            <div class="grid grid-cols-12 items-center gap-4">
              <div class="col-span-10">
                <h2 class="mt-1 text-xl font-bold tracking-tight text-gray-900 sm:text-2xl">
                  Create Image with AI
                </h2>
              </div>

              <div class="col-span-2 flex justify-end">
                <button
                  type="button"
                  (click)="closeAiModal()"
                  aria-label="Close"
                  class="rounded-xl p-2 text-gray-500 transition hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <div class="bg-white p-4 sm:p-6">
            <div
              #modalContainer
              class="h-[75vh] max-h-[720px] min-h-[560px] w-full overflow-hidden rounded-xl border border-gray-200 bg-white"
            >
              <!-- AI Engine will mount here -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="hidden col-span-12 min-w-0 md:block 2xl:col-span-3">
    <app-sidebar></app-sidebar>
  </div>
</div>